export default function isDevelopmentClaimed(organization_id): boolean {
  return organization_id !== 1;
}
